<template>
    <v-container class="pa-2">
        <v-row dense>
            <v-col cols="12">

                <!-- Header -->
                <v-card class="rounded-xl elevation-2 px-3 py-1 mb-3">
                    <div class="d-flex align-center">
                        <v-btn v-if="congId === null" icon small text color="primary" @click="chiudi">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <div class="ml-2 flex-grow-1">
                            <div class="text-subtitle-2 font-weight-bold primary--text">
                                {{ effectiveId === '0' ? 'Nuova Congregazione' : 'Congregazione ' + congregazione.nome }}
                            </div>
                        </div>
                        <v-icon color="primary" size="26">mdi-home-city-outline</v-icon>
                    </div>
                </v-card>

                <!-- Skeleton -->
                <v-card v-if="loadingCong" class="rounded-xl elevation-2 pa-4">
                    <v-skeleton-loader type="list-item-two-line, list-item-two-line, actions" />
                </v-card>

                <!-- Form -->
                <v-card v-else class="rounded-xl elevation-2">
                    <v-card-text class="pt-3 pb-2 px-3">
                        <v-form :readonly="!modificheAbilitate" v-model="valid" ref="formCongregazione">

                            <v-text-field v-model="congregazione.nome"
                                outlined rounded dense hide-details="auto"
                                :rules="[v => !!v || 'campo obbligatorio']"
                                label="Nome congregazione"
                                prepend-inner-icon="mdi-home-city-outline"
                                class="mb-2" />

                            <v-text-field v-model="congregazione.indirizzo"
                                outlined rounded dense hide-details
                                label="Indirizzo"
                                prepend-inner-icon="mdi-map-marker-outline"
                                class="mb-2" />

                            <v-text-field v-model="congregazione.giorno"
                                outlined rounded dense hide-details
                                label="Giorno adunanza"
                                prepend-inner-icon="mdi-calendar-week-outline"
                                class="mb-2" />

                            <v-row dense class="mb-2">
                                <v-col cols="6">
                                    <v-text-field v-model="congregazione.ora"
                                        outlined rounded dense hide-details
                                        label="Orario"
                                        prepend-inner-icon="mdi-clock-outline" />
                                </v-col>
                            </v-row>

                            <v-row dense class="mb-2">
                                <v-col cols="6">
                                    <v-text-field v-model="congregazione.latitudine"
                                        outlined rounded dense hide-details="auto"
                                        label="Latitudine"
                                        placeholder="es. 37.123456"
                                        :rules="[v => v == null || v.length == 0 || /^[0-9]{1,3}\.[0-9]{1,6}$/.test(v) || 'es. 37.12345']" />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="congregazione.longitudine"
                                        outlined rounded dense hide-details="auto"
                                        label="Longitudine"
                                        placeholder="es. 16.123456"
                                        :rules="[v => v == null || v.length == 0 || /^[0-9]{1,3}\.[0-9]{1,6}$/.test(v) || 'es. 16.12345']" />
                                </v-col>
                            </v-row>

                            <div class="d-flex align-center mb-4">
                                <v-btn small depressed rounded color="success"
                                    :disabled="!congregazione.latitudine || !congregazione.longitudine"
                                    @click="$openUrl('https://maps.google.it/?q=' + congregazione.latitudine + ',' + congregazione.longitudine)">
                                    <v-icon small left>mdi-map-marker-outline</v-icon>
                                    Verifica coordinate
                                </v-btn>
                            </div>

                            <div v-if="prenotazioniAttive" class="d-flex align-center px-1 mb-3">
                                <v-icon small color="grey darken-1" class="mr-3">mdi-calendar-check-outline</v-icon>
                                <span class="text-body-2 flex-grow-1">Congregazione con prenotazioni</span>
                                <v-switch v-model="congregazione.prenotazione"
                                    :disabled="!modificheAbilitate"
                                    inset dense hide-details class="mt-0 pt-0" />
                            </div>

                        </v-form>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions class="px-4 py-3">
                        <v-btn text rounded @click="chiudi">Annulla</v-btn>
                        <v-btn v-if="puoEliminare"
                            text rounded small color="error"
                            @click="dialogElimina = true">
                            <v-icon small left>mdi-delete-outline</v-icon>
                            Elimina
                        </v-btn>
                        <v-spacer />
                        <v-btn v-if="modificheAbilitate"
                            color="primary" rounded depressed
                            :disabled="!congregazione.nome" :loading="loadingCong"
                            @click="save">
                            Salva
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>

        <!-- Dialog conferma eliminazione -->
        <v-dialog v-model="dialogElimina" max-width="360" persistent>
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold error--text pt-4 pb-2">
                    <v-icon color="error" class="mr-2">mdi-alert-outline</v-icon>
                    Elimina congregazione
                </v-card-title>
                <v-card-text class="text-body-2 pb-2">
                    Sei sicuro di voler eliminare <strong>{{ congregazione.nome }}</strong>?<br/><br/>
                    Gli appuntamenti associati agli oratori di questa congregazione saranno trasformati in appuntamenti extra per non perdere la storia.
                    Gli oratori e la congregazione saranno eliminati in modo irreversibile.
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                    <v-btn text rounded @click="dialogElimina = false">Annulla</v-btn>
                    <v-spacer />
                    <v-btn color="error" rounded depressed :loading="loadingElimina" @click="eliminaCongregazione">
                        Elimina
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackSuccess" timeout="2000" color="success" bottom>
            <v-icon dark class="mr-2">mdi-checkbox-marked-circle</v-icon>
            Operazione eseguita con successo.
        </v-snackbar>
        <v-snackbar v-model="snackError" timeout="2000" color="error" bottom>
            <v-icon dark class="mr-2">mdi-alert-circle</v-icon>
            Errore durante l'esecuzione dell'operazione.
        </v-snackbar>
        <v-snackbar v-model="snackInfo" timeout="2000" color="info" bottom>
            <v-icon dark class="mr-2">mdi-key-outline</v-icon>
            Credenziali copiate in memoria.
        </v-snackbar>
        <v-snackbar v-model="snackWarning" timeout="6000" color="warning" bottom>
            <v-icon dark class="mr-2">mdi-alert-outline</v-icon>
            {{ snackWarningMsg }}
        </v-snackbar>
    </v-container>
</template>

<script>
import { callService, callPost, SUPERADMIN_CODE } from '@/modules/utilities.js'
import { bus } from '@/main.js'
import { VSkeletonLoader } from 'vuetify/lib'

export default {
    components: { VSkeletonLoader },
    props: {
        congId: { type: String, default: null },
    },
    data: () => ({
        congregazione: {},
        valid: false,
        loadingCong: false,
        loadingElimina: false,
        dialogElimina: false,
        snackInfo: false,
        snackSuccess: false,
        snackError: false,
        snackWarning: false,
        snackWarningMsg: '',
        snackCancel: false,
        snackRemote: false,
        prenotazioniAttive: false,
        SUPERADMIN_CODE: 0,
    }),
    computed: {
        effectiveId() {
            return this.congId || this.$route.params.id;
        },
        modificheAbilitate() {
            const o = this.$store.state.oratore;
            if (o.codice == this.SUPERADMIN_CODE || o.isAdmin) return true;
            if (this.congregazione && o.congregazione &&
                o.congregazione.id == this.congregazione.id &&
                (o.isCoordinatore || o.isAssistente)) return true;
            return false;
        },
        puoEliminare() {
            if (this.effectiveId === '0') return false;
            const o = this.$store.state.oratore;
            const isSuperAdmin = o.codice == this.SUPERADMIN_CODE;
            const isAdmin = o.isAdmin;
            if (!isSuperAdmin && !isAdmin) return false;
            // L'admin di circoscrizione non può eliminare la propria congregazione
            if (!isSuperAdmin && o.congregazione && o.congregazione.id == this.congregazione.id) return false;
            return true;
        },
    },
    methods: {
        chiudi() {
            if (this.congId !== null) {
                this.$emit('close');
            } else {
                this.$router.back();
            }
        },
        async loadData() {
            this.$nextTick(() => {
                if (this.$refs.formCongregazione) this.$refs.formCongregazione.resetValidation();
            });
            this.loadingCong = true;
            this.SUPERADMIN_CODE = SUPERADMIN_CODE;
            this.congregazione = { id: '0' };
            this.prenotazioniAttive = this.$store.state.circoscrizione.prenotazione;
            const id = this.effectiveId;
            if (id !== '0') {
                const param = [this.$store.state.idCircoscrizione];
                const lista = await callService(`/api/congregazione?id=${encodeURIComponent(id)}`, param);
                this.congregazione = lista[0].congregazione;
                this.congregazione.prenotazione = await callService('/api/congregazione/haPrenotazioni', [this.$store.state.idCircoscrizione, id]);
            }
            this.loadingCong = false;
        },
        async eliminaCongregazione() {
            this.loadingElimina = true;
            try {
                const paramJson = {
                    partition: this.$store.state.partition,
                    username: this.$store.state.oratore.codice,
                    token: this.$store.state.oratore.token,
                    idCircoscrizione: this.$store.state.idCircoscrizione,
                    idCongregazione: this.congregazione.id,
                };
                const url = process.env.VUE_APP_SERVER + '/api/congregazione/eliminaCongregazione';
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.$store.state.accessToken,
                    },
                    body: JSON.stringify(paramJson),
                });
                this.dialogElimina = false;
                if (response.ok) {
                    bus.$emit('congregazioni-reload', null);
                    this.chiudi();
                } else if (response.status === 400) {
                    const body = await response.text().catch(() => '');
                    if (body.includes('has_admin')) {
                        this.snackWarningMsg = 'La congregazione contiene un App Admin. Prima rimuovi il privilegio App Admin all\'oratore e poi elimina la congregazione.';
                    } else {
                        this.snackWarningMsg = 'Operazione non consentita.';
                    }
                    this.snackWarning = true;
                } else {
                    this.snackError = true;
                }
            } catch {
                this.snackError = true;
                this.dialogElimina = false;
            } finally {
                this.loadingElimina = false;
            }
        },
        async save() {
            this.loadingCong = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                congregazione: this.congregazione,
                prenotazione: this.congregazione.prenotazione
            };
            const congregazione = await callPost('/api/congregazione/saveCongregazione', paramJson);
            this.snackSuccess = (congregazione != null);
            this.snackError = (congregazione == null);
            this.loadingCong = false;
            if (congregazione) {
                bus.$emit('congregazioni-reload', congregazione);
            }
        }
    },
    async mounted() {
        // Usato come componente inline (tablet detail): congId è una prop
        if (this.congId !== null) await this.loadData();
    },
    async activated() {
        // Usato via router-view (mobile/desktop)
        await this.loadData();
    }
}
</script>

<style scoped>
/* Icone dentro i campi: più piccole e sottili */
:deep(.v-text-field .v-input__prepend-inner .v-icon),
:deep(.v-text-field .v-input__append-inner .v-icon) {
    font-size: 16px !important;
    opacity: 0.55;
}
:deep(.v-text-field:hover .v-input__prepend-inner .v-icon),
:deep(.v-text-field:hover .v-input__append-inner .v-icon),
:deep(.v-text-field.v-input--is-focused .v-input__prepend-inner .v-icon),
:deep(.v-text-field.v-input--is-focused .v-input__append-inner .v-icon) {
    opacity: 0.85;
}
</style>
